module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "uk-card uk-card-default uk-card-small uk-card-hover",
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    staticClass: "uk-card-body"
  }, [_c('div', [_c('a', {
    staticClass: "tm-image-link",
    attrs: {
      "href": _vm.ShopItem.href
    }
  }, [(_vm.ShopItem.image) ? _c('img', {
    attrs: {
      "src": _vm.ShopItem.image.src,
      "alt": _vm.ShopItem.image.title
    }
  }) : _c('span', {
    staticClass: "uk-text-muted",
    attrs: {
      "uk-icon": "icon: image; ratio: 4;"
    }
  }), _vm._v(" "), _c('canvas', {
    attrs: {
      "width": "300",
      "height": "300"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "tm-item-card-info"
  }, [_c('div', {
    staticClass: "tm-item-card-info-header"
  }, [_c('a', {
    staticClass: "tm-item-card-title",
    attrs: {
      "href": _vm.ShopItem.href
    }
  }, [_vm._v(_vm._s(_vm.ShopItem.name))]), _vm._v(" "), (_vm.ShopItem.description) ? _c('div', {
    staticClass: "tm-item-card-description",
    domProps: {
      "innerHTML": _vm._s(_vm.ShopItem.description)
    }
  }) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "uk-card-footer"
  }, [_c('shop-item-prices', _vm._g({
    attrs: {
      "shop-item": _vm.ShopItem,
      "shop-item-prices": _vm.ShopItemPrices,
      "shop-order-item": _vm.ShopOrderItem,
      "shop-item-warehouses": _vm.ShopItemWarehouses
    }
  }, _vm.$listeners))], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c50385b2","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/Shop/ShopGroup/ShopItemBlock.vue
// module id = 96
// module chunks = 0